import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { STATE_BENEFIT_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import RecordsSection, { RecordsSubSectionProps } from './records-section'

const StateBenefits = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => (
  <RecordsSection
    heading="2.10 State benefits"
    cardType="Benefit"
    addLabel="Add benefit"
    toggleName="stateBenefitsSectionActive"
    sectionActive={sectionActive}
    saveProbateEstateField={saveProbateEstateField}
    collection={collection}
    schema={STATE_BENEFIT_SCHEMA}
    renderFields={({ handleSave, pairedFieldSpan }) => (
      <>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="providerName"
            label="Benefit type"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="referenceNumber"
            label="Reference number"
            handleSave={handleSave}
          />
        </Grid.Item>
      </>
    )}
  />
)

export default StateBenefits
